export enum MY_CONNECT_TYPE {
  Unknown = 'unknown',
  /** for tab only */
  Contact = 'contact',
  /** for tab only */
  Company = 'company',
  Customer = 'customer',
  Partner = 'partner',
  PartnerContact = 'partnerContact',
  Distributor = 'distributor',
  DistributorContact = 'distributorContact',
  WebHelp = 'webHelpEmployee',
  HP = 'hpEmployee',
  Other = 'addressBook',
  Favourite = 'favourite',
}
